import type { PropsWithChildren } from "react"
import type { RequestContextProps } from "./RequestContext"
import { RequestContext } from "./RequestContext"

interface RequestContextProviderProps extends PropsWithChildren {
	context: RequestContextProps
}

export const RequestContextProvider = ({ children, context }: RequestContextProviderProps) => (
	<RequestContext.Provider value={context}>{children}</RequestContext.Provider>
)
